import React, { useCallback } from 'react';
import {ReadOnlySupport} from "./utils/ReadOnlySupport";
import {Select as AntSelect} from "antd";
import {ReadOnlyBox} from "./utils/ReadOnlyBox";
import {getOptions, SelectHelper} from "./utils/helper";

function MultiSelectReadOnly(props) {
    const { value, disabled } = props;
    const { options, children } = props;

    function getTags(value) {
        const newOptions = getOptions(options, children) || [];

        function iter(value) {
            const label = newOptions.find(option => option.value === value)?.label || value;
            return (
                <div className="ant-select-selection-overflow-item">
                    <span className="ant-select-selection-item">
                        <span className="ant-select-selection-item-content">
                            {label}
                        </span>
                    </span>
                </div>
            );
        }

        return Array.isArray(value) ? value.map(iter) : [iter(value)];
    }

    return (
        <ReadOnlyBox className="ant-select-multiple" disabled={disabled}>
            <div className="ant-select-selector">
                <div className="ant-select-selection-overflow">
                    { getTags(value) }
                </div>
            </div>
        </ReadOnlyBox>
    );
}

export const MultiSelect = React.forwardRef((props, ref) => {
    const { children, popupContainerId, ...restProps } = props;

    const whenReadOnly = useCallback(() => <MultiSelectReadOnly {...props} />, [props]);

    const notReadOnly = useCallback(() => (
        <AntSelect
            mode="multiple"
            {...restProps}
            ref={ref}
            getPopupContainer={SelectHelper.getPopupContainer(popupContainerId)}
        >
            {children}
        </AntSelect>
    ), [children, popupContainerId, ref, restProps]);

    return <ReadOnlySupport
        {...props}
        whenReadOnly={whenReadOnly}
        notReadOnly={notReadOnly}
    />;
});

MultiSelect.Option = AntSelect.Option;
MultiSelect.OptGroup = AntSelect.OptGroup;
